import React from "react";
import { Link } from "react-router-dom";
import Logo from "components/Logo";
function Nav() {
  return (
    <nav className="p-4 hidden lg:flex items-center justify-between  bg-secondary">
      <ul className=" text-primary font-bold text-xl  align-center justify-center  flex  items-center ">
        <li className="align-center mr-6 flex  transition duration-300 ease-in-out">
          <Link to="/about-courses">عن الشركة</Link>
        </li>
        <li className="align-center  mr-6 flex transition  duration-300 ease-in-out">
          <Link to="/community">الدستور</Link>
        </li>
        <li className="align-center  flex mr-6  transition duration-300 ease-in-out">
          <Link to="/Blog">في الإعلام</Link>
        </li>
        <li className="align-center  flex mr-6  transition duration-300 ease-in-out">
          <Link to="/Blog">ثمانية الخلاقة</Link>
        </li>
        <li className="align-center  flex mr-6  transition duration-300 ease-in-out">
          <Link to="/Blog">الوظائف</Link>
        </li>
        <li className="align-center  flex mr-6  transition duration-300 ease-in-out">
          <Link to="/Blog">المدونة</Link>
        </li>
        <li className="align-center  flex mr-6  transition duration-300 ease-in-out">
          <Link to="/Blog" className="font-bold">
            اتصل بنا
          </Link>
        </li>
      </ul>
      <ul className="  align-center  flex  items-center justify-center">
        <li
          className="align-center text-center p-2 pl-4 pr-4 rounded-full border-2 font-semibold
        border-primary text-primary"
        >
          <Link>الذهاب لموقع ثمانية</Link>
        </li>
      </ul>
    </nav>
  );
}

export default Nav;
